<div class="lead-page">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>Lead Management Dashboard</h2>
        <p>Track ANPR enquiries, follow-ups, demos, and conversion progress.</p>
      </div>
      <div class="lead-actions">
        <button class="lead-btn" (click)="goTo('lead-management/leads/new')">Create Lead</button>
        <button class="lead-btn-secondary" (click)="goTo('lead-management/leads')">View Leads</button>
      </div>
    </div>

    <div class="lead-loading" *ngIf="loading">Loading dashboard...</div>

    <div class="lead-dashboard-grid" *ngIf="!loading">
      <div class="lead-card lead-card-clickable" *ngFor="let card of cards" (click)="openCard(card.key)">
        <span>{{ card.label }}</span>
        <strong>{{ stats[card.key] || 0 }}</strong>
      </div>
    </div>
  </div>
</div>
